export default __webpack_public_path__ + "images/models/37e7882aac2768d0043e71737e483f6e.usdz";